import React from 'react';
import { useNavigate } from 'react-router-dom';
// import SubNav from '../components/subNav';
import { baseUrl } from '../config';
import SEO from '../components/SEO';



const teamMembers = [
  { id: 1, name: 'Alice Johnson', role: 'Director', age: 35 },
  { id: 2, name: 'Bob Smith', role: 'Producer', age: 40 },
  { id: 3, name: 'Charlie Adams', role: 'Cinematographer', age: 28 },
  { id: 4, name: 'Diane Brown', role: 'Editor', age: 30 },
  // Add more team members as needed
];

const Team = () => {
  const navigate = useNavigate();

  // Navigate to schedule page
  const handleCheckAvailability = (id) => {
    navigate(`/team-schedule/${id}`);
  };
  return (
    <>
    <SEO
      title="Production Team"
      description="Manage your film production team members, roles, and assignments on ProducerBuddy."
      url="https://producerbuddy.pilomation.com/team"
      robots="noindex, nofollow"
    />
    {/* <SubNav/> */}
    <div className='flex '>
      {/* <div className="w-64 bg-gray-800 text-white p-5 space-y-6">
        <h1 className="text-2xl font-bold"><Link to='/production-house'>Production Dashboard</Link></h1>
        <nav>
          <ul className="space-y-4 mt-4">
            <li className="hover:text-yellow-400"><Link to='/jobpostings'>Job Postings</Link></li>
            <li className="hover:text-yellow-400">Pre-Production Tools</li>
            <li className="hover:text-yellow-400">Production Status</li>
            <li className="hover:text-yellow-400">Post-Production Tools</li>
            <li className="hover:text-yellow-400"><Link to='/collaborations'>Collaborations</Link></li>
            <li className="hover:text-yellow-400"><Link to='/team'>Team</Link></li>
          </ul>
        </nav>
      </div> */}
      <div className="mt-4 w-100">
      <h1 className="text-3xl font-bold mb-8 text-center" style={{fontSize:'24px'}}>Our Team</h1>
      <div className="overflow-x-auto">
        <table className="min-w-full bg-white shadow-md rounded-lg">
          <thead>
            <tr>
              <th className="py-3 px-6 bg-gray-200 font-semibold text-gray-600 uppercase tracking-wider text-left">
                Name
              </th>
              <th className="py-3 px-6 bg-gray-200 font-semibold text-gray-600 uppercase tracking-wider text-left">
                Role
              </th>
              <th className="py-3 px-6 bg-gray-200 font-semibold text-gray-600 uppercase tracking-wider text-left">
                Age
              </th>
              <th className="py-3 px-6 bg-gray-200 font-semibold text-gray-600 uppercase tracking-wider text-center">
                Availability
              </th>
            </tr>
          </thead>
          <tbody>
            {teamMembers.map((member, index) => (
              <tr key={index} className="border-b">
                <td className="py-4 px-6 text-gray-700">{member.name}</td>
                <td className="py-4 px-6 text-gray-700">{member.role}</td>
                <td className="py-4 px-6 text-gray-700">{member.age}</td>
                <td className="py-4 px-6 text-center">
                  <button className="bg-green-500 text-white px-4 py-2 rounded hover:bg-green-600" onClick={() => handleCheckAvailability(member.id)}>
                    Check Availability
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
    </div>
    
    </>
    
  );
};

export default Team;

